import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const soulmateRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/soulmate",
  component: lazyRouteComponent(() => import("./lazy-pages"), "SoulmatePage"),
})
